// extracted by css-extract-rspack-plugin
export default {"truncate":"PyAxtmhheYRVFQq0"};